export const extractProductsFromWidgets = (widgetList) => {
    if (!widgetList) {
        return {
            topProducts: {},
            newProducts: {},
            category1: {},
            category2: {},
            mostPopular: {},
            handpicked1: {},
            handpicked2: {},
            handpicked3: {},
            deals: {},
        };
    }
    const productWidgets = widgetList.filter((widget) => widget.type === 'productsWidget');
    const topProductsWidget = productWidgets.find(
        (widget) => widget.widget?.style === 'topProductsWidget',
    );
    const newProductsWidget = productWidgets.find((widget) =>
        widget.widget?.slug?.includes('new_products'),
    );
    const categoryWidgets = productWidgets.filter((widget) =>
        widget.widget?.slug?.includes('category'),
    );
    const mostPopularProducts = productWidgets.find((widget) =>
        widget.widget?.slug?.includes('top_ordered'),
    );
    const handpickedProductsWidgets = productWidgets.filter((widget) =>
        widget.widget?.slug?.includes('handpicked'),
    );
    const dealProductsWidget = productWidgets.find((widget) =>
        widget.widget?.slug?.includes('deal_products'),
    );

    const concat = (...arrays) => [].concat(...arrays.filter(Array.isArray));

    return concat(
        topProductsWidget?.widget?.products ?? null,
        newProductsWidget?.widget?.products ?? null,
        categoryWidgets[0]?.widget?.products ?? null,
        categoryWidgets[1]?.widget?.products ?? null,
        mostPopularProducts?.widget?.products ?? null,
        handpickedProductsWidgets[0]?.widget?.products ?? null,
        handpickedProductsWidgets[1]?.widget?.products ?? null,
        handpickedProductsWidgets[2]?.widget?.products ?? null,
        dealProductsWidget?.widget?.products ?? null,
    );
};
